<template>
  <tr
    v-if="!dataRow.isHide"
    :class="[
      'ms-tr',
      dataRow.IsBold ? 'ms-format-bold' : '',
      dataRow.IsItalic ? 'ms-format-italic' : '',
      { 'action-hover': isShowRowAction && actionInline },
      { 'not-has-border-around': !hasBorderAround },
    ]"
    tabindex="0"
    :indexRow="dataRow.rowIndex || index"
    @keydown="row_keydown"
    @click="handleClickRow"
  >
    <td
      v-if="multiple"
      class="ms-td multiple-cell sticky"
      :class="[{ 'ms-col-td-multiple': !hasBorderAround }]"
    >
      <ms-checkbox
        v-if="
          !isCustomCheckBox || (isCustomCheckBox && !dataRow.isDisabledCheckBox)
        "
        ref="multiple"
        :key="0"
        :model-value="isChecked"
        class="justify-center"
        check-only
        :disabled="disabledCheckedMultipleTbody"
        @input="checkMultiple"
      />
    </td>
    <td
      v-if="serial"
      :key="0"
      class="ms-td serial text-center"
      :class="{ sticky: hasLockColumn }"
      :style="{ left: serialOffsetLeft }"
    >
      {{ pageSize * (currentPage - 1) + index + 1 }}
    </td>
    <td
      v-for="(col, index) in columns"
      :key="col.dataField"
      :ref="`td-${col.dataField}`"
      class="ms-td ms-col-td"
      :class="[
        `text-${col.align || 'left'}`,
        col.cssCellClass,
        { sticky: col.lock },
        index === columns?.length - 1 ? 'ms-col-td-last' : '',
      ]"
      :style="styleWidth(col, false)"
    >
      <!-- Nếu type của cột là custom thì truyền template của slot vào -->
      <slot
        v-if="
          col.type === 'custom' ||
          col.columnType == $ms.constant.ColumnType.Custom
        "
        name="grid-cell"
        :col="col"
      />
      <div
        ref="rowAction"
        class="row-actions"
        v-else-if="col.columnType == $ms.constant.ColumnType.Action"
      >
        <div
          v-for="action in actionInline"
          :key="action.command"
          class="item"
          @click.prevent="rowActionClick(action, $event)"
          v-tooltip="action.text"
        >
          <div :class="['icon16 ic-24', action.icon]" />
        </div>
      </div>
      <div v-else>
        <!-- Nếu cột có truyền template vào thì component được truyền vào phải được khai báo ở global -->
        <component
          :is="col.template"
          v-if="col.template"
          :data="dataRow"
          :column="col"
          :data-row="dataRow"
          :col="col"
          :row-selected="rowSelected"
          :is-selected="isSelected"
        />
        <div v-else-if="col.isSerial" :class="[`justify-center`, col.cssClass]">
          <span>{{ index + 1 }}</span>
        </div>
        <!-- Kiểu Text nhưng có dạng nhiều dòng value= MORE_DETAILS-->
        <div
          v-else-if="dataRow[col.dataField] === 'MORE_DETAILS'"
          :class="[
            `text-${col.align || 'left'}`,
            col.cssClass,
            'text-overflow',
            'icon24',
            'more-rows',
          ]"
          :title="titleToolTip(dataRow, col)"
          data-animation="animated bounceInDown"
          data-toggle="tooltip"
          @click="viewMoreDetails(col, dataRow)"
        >
          <span />
        </div>
        <div
          v-else
          :class="[
            `text-${col.align || 'left'}`,
            col.cssClass,
            'text-overflow',
            $ms.constant.FormatType.Checkbox,
            col.formatType,
          ]"
          :title="titleToolTip(dataRow, col)"
          data-animation="animated bounceInDown"
          data-toggle="tooltip"
        >
          <!-- v-tooltip="{ content:titleToolTip(dataRow, col), placement: 'top'}" -->
          <!-- kiểu checkbox -->
          <span
            v-if="col.formatType === $ms.constant.FormatType.Checkbox"
            :ref="`text-${col.dataField}`"
            class="cell-checkbox"
          >
            <div class="icon" :class="{ checked: dataRow[col.dataField] }" />
          </span>
          <!-- kiểu html -->
          <div
            v-else-if="col.formatType === $ms.constant.FormatType.Html"
            class="customStyleHtml"
            v-html="dataRow[col.dataField]"
          />
          <span
            v-else
            :ref="`text-${col.dataField}`"
            :class="[
              `text-${col.align || 'left'} ${
                col.linkedForm ? 'text-link' : ''
              }`,
            ]"
            :title="
              dataRow[col.dataField] != null
                ? $ms.format.formatData(dataRow[col.dataField], {
                    formatType: col.formatType,
                    optionFormat: col.optionFormat,
                    enumName: col.enum,
                  })
                : col.customNullData || ''
            "
            @click="viewLinkedForm(col, dataRow)"
          >
            {{
              dataRow[col.dataField] != null
                ? $ms.format.formatData(dataRow[col.dataField], {
                    formatType: col.formatType,
                    optionFormat: col.optionFormat,
                    enumName: col.enum,
                  })
                : col.customNullData || ''
            }}
          </span>

          <!-- <div
            :class="['mi', 'mi-24', col.icon.type]"
            v-if="col.icon && col.icon.show(dataRow, col)"
            v-tooltip="{ ...col.icon.tooltip }"
          ></div> -->
        </div>
      </div>
    </td>
    <td v-if="$slots.widget" :key="100" class="ms-td widget-item sticky">
      <slot name="widget" />
    </td>
    <ms-popover
      :target="actionBoxRef"
      :is-active="isOpenActionMore"
      :min-height="52"
      :width="100"
      :custom-style="{
        padding: '8px 8px',
      }"
      class="mt-1"
      :has-arrow="true"
      transition="ms-side-bottom-top"
      @onClose="closeActionMore"
    >
      <div
        v-for="action in actionContext"
        :key="action.command"
        :class="[`li-${action.command}`, 'action-menu menu-item']"
        @click.prevent="rowActionClick(action, $event)"
      >
        <div
          href="javascript:void(0)"
          :class="['flex items-center', action.cls]"
        >
          <div :class="['icon16 ic-24 mr-1', action.icon]" />
            {{ action.text }}
          </div>
      </div>
    </ms-popover>
  </tr>
</template>
<script>
import { object } from '@amcharts/amcharts5';
import MsPopover from '@/components/popover/MsPopover.vue';
export default {
  name: 'MsTr',
  components: {
    MsPopover
  },
  props: {
    // Có chọn khi click vào dòng ko
    isSelectWhenClickRow: {
      type: Boolean,
      default: false,
    },
    //Lưu thông tin của các cột
    columns: {},
    //Lưu dữ liệu của dòng
    dataRow: {},
    //Ẩn/hiện cột checkbox tích chọn nhiều cột
    multiple: {
      default: false,
      type: Boolean,
    },
    //Trạng thái tích chọn ở cột multiple
    isSelected: {
      default: false,
      type: Boolean,
    },
    index: {
      default: null,
      type: Number,
    },
    serial: {
      default: false,
      type: Boolean,
    },
    currentPage: {
      default: 1,
      type: Number,
    },
    pageSize: {
      default: 20,
      type: Number,
    },
    rowSelected: {
      default: null,
    },
    rowActions: {
      default: null,
      type: [Object, Array],
    },
    actionInlineCount: {
      type: Number,
    },
    disabledCheckedMultipleTbody: {
      default: false,
      type: [Boolean, Function],
    },
    hasLockColumn: {
      type: Boolean,
      default: false,
    },
    isCheckedAll: {
      default: () => false,
      type: Boolean,
    },
    isCustomCheckBox: {
      default: false,
      type: Boolean,
    },
    serialOffsetLeft: {
      type: String,
      default: '0',
    },
    // Có border xung quanh ko
    hasBorderAround: {
      type: Boolean,
      default: false,
    },

    /**
     * Custom hiển thị khi dữ liệu null
     * NTDIEM 12/06/2023
     */
    customNullData: {
      type: String,
      default: '',
    },

    /**
     * Có hiển thị row action không
     * Mặc định là false vì hiện tài nhiều nơi đang không dùng base
     */
    isShowRowAction: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      /**
       * Style đặt vị trí hiển thị row action
       */
      rowActionStyle: {
        top: 0,
        left: 0,
      },
      // Có mở action more không
      isOpenActionMore: false,
      actionBoxRef: null
    };
  },
  computed: {
    /**
     * Action hiển thị trên dòng chọn ngay
     */
    actionInline() {
      let result = [],
        actions = this.rowActions;

      if (actions) {
        if (actions.length > this.actionInlineCount) {
          for (let i = 0; i < this.actionInlineCount - 1; i++) {
            result.push(actions[i]);
          }

          result.push({
            command: 'MORE',
            icon: 'ic-more',
            text: this.moreText,
          });
        } else {
          for (let i = 0; i < actions.length; i++) {
            result.push(actions[i]);
          }
        }
      }

      return result;
    },
    /**
     * Action hiển trong more context
     */
    actionContext() {
      let result = [],
        actions = this.rowActions;

      if (actions && actions.length > this.actionInlineCount) {
        for (let i = this.actionInlineCount - 1; i < actions.length; i++) {
          result.push(actions[i]);
        }
      }

      return result;
    },
    /**
     * Nếu có check all sẽ thực hiện check all
     */
    isChecked() {
      const { disabledCheckedMultipleTbody, isCheckedAll, isSelected } = this;
      return disabledCheckedMultipleTbody ? false : isCheckedAll || isSelected;
    },
  },
  created() {
    const me = this;
    me.moreText = me.$t('i18nCommon.command.more');
  },
  methods: {
    /**
     * Xử lý khi bấm vào dòng
     * @param {object} e event object
     * @author: BMThang(06/02/2023)
     */
    handleClickRow(e) {
      if (!this.isSelectWhenClickRow) {
        return;
      }
      // Nếu bấm vào checkbox thì ko làm j để checkbox làm việc
      if (e.target.className.includes('ms-checkbox-control')) {
        return;
      }
      const checked = !this.isSelected;
      this.checkMultiple({
        target: {
          tagName: 'input',
          checked,
        },
      });
    },

    //Cập nhật lại độ rộng của cột theo độ rộng cấu hình
    //Created by LTDAT
    styleWidth(col, widget) {
      let rs = {};

      if (col.lock) {
        rs.left = (col.stickyOffset || 0) + 'px';
      }

      if (!widget) {
        rs['max-width'] = col.width + 'px';
      }

      if (col.maxWidth) {
        rs['max-width'] = col.maxWidth + 'px';
      }

      this.$emit('styleColumn', col, this.dataRow, rs);

      return rs;
    },

    drilldownClick(col, dataRow, e) {
      let metaData = {
        col: col,
        dataRow: dataRow,
      };
      this.$emit('drilldownClick', metaData, e);
    },

    //(Click vào các cột có dạng số nhiều.(đại diện cho nhiều dòng chi tiết)
    //Created by TVLOI 22.05.2021
    viewMoreDetails(col, dataRow, e) {
      dataRow.moreDetails = true;
      let metaData = {
        col: col,
        dataRow: dataRow,
      };
      this.$emit('viewMoreDetails', metaData, e);
    },

    /**
     * Hiển thị form chi tiết khi click vào ô (nếu có config linkedForm)
     * dtnga3 (14.07.2022)
     */
    viewLinkedForm(col, dataRow, e) {
      if (col && col.linkedForm && col.linkedForm != '') {
        this.$emit('viewLinkedForm', col, dataRow, e);
      }
    },

    //Emit sự kiện ấn phím ra ngoài grid
    //Created by LTDAT(13/06/2020)
    row_keydown(e) {
      const me = this;
      me.$emit('keydown', me.dataRow, e);
    },
    //Sự kiện click vào nút chọn ở cột multiple
    //Created by LTDAT (28.05.2020)
    //NCPHUOC 28/03/2022: emit checkbox event ra ngoài grid
    checkMultiple(e) {
      const me = this;
      const checked =
        e.target.tagName.toLowerCase() === 'input' ? e.target.checked : false;
      me.$emit('clickMultiple', me.dataRow, checked);
    },

    /**
     * Show tooltip cho nội dung cell
     */
    titleToolTip(dataRow, col) {
      return '';
      let me = this;
      if (col.formatType == me.$ms.constant.FormatType.Html) {
        if (dataRow[col.dataField]) {
          return me.stripHtml(dataRow[col.dataField]);
        } else {
          return null;
        }
      } else {
        //Format dạng MOREDETAILS
        if (dataRow[col.dataField] === 'MORE_DETAILS') {
          return me.$t('i18nCommon.command.ViewMoreDetails');
        }

        //pvduy 24/04/2021: xử lý riêng toolip giá trị khác trong báo cáo thống kê số lượng theo tình trạng.
        if (
          col.dataField === 'AssetStatusName' &&
          dataRow[col.dataField] === 'Khác'
        ) {
          return 'Báo mất, báo hỏng, đề nghị thanh lý, đang điều chuyển';
        } else {
          return this.$ms.format.formatData(dataRow[col.dataField], {
            formatType: col.formatType,
            enumName: col.enum,
            dataRow: dataRow,
            optionFormat: col.optionFormat,
          });
        }
      }
    },
    /**
     * convert html code to text
     */
    stripHtml(source) {
      let output;
      source = source.toString();
      //get rid of HTML tags
      output = source.replace(/<[^>]*>/g, '');
      output = output.replace(/&nbsp;/g, ' ');
      output = output.replace(/\n/g, '; ');
      return output;
    },
    showActionSub(action, event) {
      const me = this;
      if (action.subMenu) {
        let liPersent = event.toElement;
        if (liPersent) {
          while (!liPersent.className.contains('actionSub')) {
            liPersent = liPersent.offsetParent;
          }
          let liPosition = liPersent.getBoundingClientRect(); // Position của thẻ li (action cha)
          let [menuSub] = me.$refs.actionSubMenu; // Position menu sub
          let elSub = menuSub.$el; // element sub
          let elSubPosition = menuSub.$el.getBoundingClientRect(); // Position của menusub
          if (elSub) {
            // gán lại style cho  element sub, đang tạm gán thôi, chưa tính trường hợp dàn lên trên nếu top quá to hoặc dàn sang phải nếu left quá nhỏ
            elSub.style.top = liPosition.top + 'px';
            elSub.style.left = liPosition.left - elSubPosition.width + 'px';
          }
        }
      }
    },
    /**
     * Xử lý click vào action
     */
    rowActionClick(action, event) {
      const me = this;
      if (action.command === "MORE") {
        me.actionBoxRef = event.target;
        me.isOpenActionMore = !me.isOpenActionMore;
      } else if (action.command === "Ultility") {
        event.preventDefault();
        event.stopPropagation();
      } else {
        me.isOpenActionMore = false;
        me.$emit("rowactionclick", action.command, me.dataRow, event);
      }
    },
    /**
     * Xử lý đóng nút more
     */
    closeActionMore() {
      const me = this;

      me.isOpenActionMore = false;
    }
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';
@import '@/assets/scss/components/MsTrViewer.scss';
</style>
